// 🎨 BRANDING CONFIGURATION - SEARCH.INC INSPIRED
// Dark theme with flowing cyan particle effects

export const brandConfig = {
  // App Identity - Search.Inc Style
  appName: "Search.Inc",
  tagline: "*Actually not evil.",
  companyName: "Search.Inc", 
  
  // Logo Configuration
  logo: {
    // Canonical brand mark (IJ-175 · 2026-07-30 · SEARCH.INC wordmark with tagline built in).
    imageUrl: "/searchinc-logo.png",
    altText: "Search.Inc — Actually not evil",

    // Icon fallback (retained for any legacy consumer that opts out of the image).
    useIcon: false,
    iconComponent: "Search",
  },
  
  // Color Scheme - Dark theme with cyan/teal accents
  colors: {
    primary: "#00d4ff",      // Bright cyan (particle glow)
    secondary: "#0891b2",    // Teal blue  
    accent: "#06b6d4",       // Cyan accent
    success: "#10b981",      // Success states
    warning: "#f59e0b",      // Warning states
    error: "#ef4444",        // Error states
    // Dark theme specific colors
    dark: "#000000",         // Pure black background
    darkSecondary: "#1a1a1a", // Slightly lighter black
    glow: "#00ffff",         // Bright glow effect
  },
  
  // Typography - Clean modern sans-serif
  fonts: {
    primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    logo: "'Inter', sans-serif", // Clean, bold for logo
    tagline: "'Inter', sans-serif", // Slightly lighter for tagline
  },
  
  // Layout & Styling - Dark futuristic theme
  theme: {
    borderRadius: "12px",         // More rounded corners
    shadowIntensity: "xl",        // Strong shadows for dark theme
    backgroundStyle: "particles", // Particle effect background
    isDarkTheme: true,           // Enable dark theme mode
    glowEffect: true,            // Enable glow effects
  },
  
  // Feature Labels (customize terminology)
  labels: {
    documents: "Documents",
    entities: "Knowledge Entities", 
    relationships: "Connections",
    query: "Ask Question",
    upload: "Upload & Analyze",
    explore: "Explore Knowledge",
  },
  
  // Custom CSS Classes (for advanced styling)
  customClasses: {
    headerBg: "bg-white", // or "bg-gray-900" for dark header
    cardStyle: "bg-white shadow-sm", // Card appearance
    buttonStyle: "brand-gradient", // Button styling
  }
};

// Helper function to apply brand colors to CSS variables
export const applyBrandColors = (colors) => {
  const root = document.documentElement;
  root.style.setProperty('--brand-primary', colors.primary);
  root.style.setProperty('--brand-secondary', colors.secondary);
  root.style.setProperty('--brand-accent', colors.accent);
  root.style.setProperty('--brand-success', colors.success);
  root.style.setProperty('--brand-warning', colors.warning);
  root.style.setProperty('--brand-error', colors.error);
};

// Apply brand font
export const applyBrandFont = (fontFamily) => {
  document.body.style.fontFamily = fontFamily;
};